module.exports = __webpack_public_path__ + "static/media/testad1.085990f8.jpg";